import { formatDateForForm } from './dateUtils';

export const CSM_CALCULATED_DUE_COLUMNS = [
  { key: 'preflight', label: 'Preflight Due Date' },
  { key: 'cnc', label: 'CNC Due Date' },
  { key: 'initialAssembly', label: 'Initial Assembly Due Date' },
  { key: 'finishing', label: 'Finishing Due Date' },
];

// SharePoint compares against @now plus exact 24-hour intervals.
export const getCsmDueDateSeverity = (dueDate, isComplete, now = new Date()) => {
  if (!dueDate) return null;
  const date = new Date(`${dueDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) return null;
  if (isComplete) return 'complete';
  const remaining = date.getTime() - now.getTime();
  const day = 86400000;
  if (remaining < day) return 'blocked';
  if (remaining < 7 * day) return 'warning';
  if (remaining < 14 * day) return 'severeWarning';
  if (remaining < 30 * day) return 'good';
  return null;
};

// Match the North Prairie Enclosures SharePoint calculated columns exactly.
// The input is CSM Due, not the enclosure date that already subtracts two business days.
// These formulas do not skip holidays and leave weekend inputs unchanged.
export const calculateCsmEnclosureDueDates = (dueDate) => {
  const emptyDates = { preflight: '', cnc: '', initialAssembly: '', finishing: '' };
  if (!dueDate) return emptyDates;
  const normalized = formatDateForForm(dueDate);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return emptyDates;
  const [year, month, day] = normalized.split('-').map(Number);
  const due = new Date(year, month - 1, day, 12);
  if (due.getFullYear() !== year || due.getMonth() !== month - 1 || due.getDate() !== day) {
    return emptyDates;
  }

  const shift = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
  };
  const isWeekday = (date) => date.getDay() >= 1 && date.getDay() <= 5;
  const threeDaysEarlier = (date) => (
    isWeekday(date) ? shift(date, date.getDay() <= 3 ? 5 : 3) : date
  );
  const finishing = threeDaysEarlier(due);
  const initialAssembly = isWeekday(finishing) ? shift(finishing, 14) : finishing;
  const cnc = isWeekday(initialAssembly) ? shift(initialAssembly, 14) : finishing;
  const preflight = threeDaysEarlier(cnc);

  return Object.fromEntries(
    Object.entries({ preflight, cnc, initialAssembly, finishing })
      .map(([key, value]) => [key, formatDateForForm(value)])
  );
};
